import { getIsTravelApp } from "@capone/common";
import { History } from "history";
import queryStringParser from "query-string";
import { SliceStopCountFilter, TripCategory } from "redmond";

export interface IFlightParsedQuery {
  adultsCount?: number;
  childrenCount?: number;
  infantsInSeatCount?: number;
  infantsOnLapCount?: number;
  origin: string;
  originRegionType: string;
  destination: string;
  destinationRegionType: string;
  tripCategory: TripCategory;
  stopsOption?: SliceStopCountFilter;
  isTravelApp?: boolean;
}

export const parseQueryFromString = (
  queryString: string
): IFlightParsedQuery => {
  const {
    adultsCount,
    childrenCount,
    infantsInSeatCount,
    infantsOnLapCount,
    origin,
    originRegionType,
    destination,
    destinationRegionType,
    tripCategory,
    stopsOption,
  } = queryStringParser.parse(queryString);

  const { isTravelApp } = getIsTravelApp(queryString);

  return {
    adultsCount: parseInt(adultsCount as string, 10),
    childrenCount: parseInt(childrenCount as string, 10),
    infantsInSeatCount: parseInt(infantsInSeatCount as string, 10),
    infantsOnLapCount: parseInt(infantsOnLapCount as string, 10),
    origin: origin as string,
    originRegionType: originRegionType as string,
    destination: destination as string,
    destinationRegionType: destinationRegionType as string,
    tripCategory: tripCategory as TripCategory,
    stopsOption: stopsOption as SliceStopCountFilter,
    isTravelApp,
  };
};

export const parseQueryString = (
  history: History
): IFlightParsedQuery | null => {
  const queryString = history?.location?.search || "";
  return queryString ? parseQueryFromString(queryString) : null;
};
